const divTableActions = {
  noResults: 'no results found',
  noAccountable: 'Without Responsible'
};

export default divTableActions;
